import { makeStyles } from '@material-ui/core'
import { GRAY_COLORS } from 'asterX-UI'

export const useTableStyles = makeStyles(theme => ({
  pagination: {
    '& .MuiPaginationItem-root': {
      margin: 0
    },
    '& .MuiPagination-ul li:first-child button': {
      borderRadius: 8
    },
    '& .MuiPagination-ul li:last-child button': {
      borderRadius: 8
    },
    '& .MuiPagination-ul li:not(:last-child):not(:first-child) button': {
      borderRadius: 8
    }
  },
  table: {
    backgroundColor: 'white',
    borderRadius: 12,
    border: `1px solid ${GRAY_COLORS[200]}`,
    overflow: 'hidden'
  },
  title: {
    fontSize: 14,
    fontWeight: 500,
    color: GRAY_COLORS[900]
  }
}))
